import { useSimulationContext } from '../SimulationContext';

export function useSimulationId(): string {
  return useSimulationContext().simId;
}
